export const MENUITEMS = [
  {
    menutitle: "Dashboard",
    menucontent: "Dashboards",
    Items: [
      { path: `/dashboard`, icon: "home", activeTitle: "Dashboard", title: "Dashboard", type: "link" },

    ],
  },
  {
    menutitle: "Exam",
    menucontent: "Dashboards,Widgets",
    Items: [
      { path: `/test-series`, icon: "blogs", activeTitle: "test-series", title: "Exam Board", type: "link" },
      { path: `/test-details`, icon: "blogs", activeTitle: "test-details", title: "Course", type: "link" },
      { path: `/examination`, icon: "blogs", activeTitle: "examination", title: "Examinations", type: "link" },

    ],
  },
  {
    menutitle: "Recorded Class",
    menucontent: "Dashboards,Widgets",
    Items: [
      { path: `/recorded-subject`, icon: "blogs", activeTitle: "recorded-subject", title: "Recorded Subject", type: "link" },
    ],
  },
  {
    menutitle: "Live Class",
    menucontent: "Dashboards,Widgets",
    Items: [
      { path: `/live-subject`, icon: "blogs", activeTitle: "live-subject", title: "Live Subject", type: "link" },
    ],
  },
  {
    menutitle: "E Notes",
    menucontent: "Dashboards,Widgets",
    Items: [
      { path: `/enotes-subject`, icon: "blogs", activeTitle: "enotes-subject", title: "E Notes Subject", type: "link" },
    ],
  },
  {
    menutitle: "Bodmas TestSeries",
    menucontent: "Dashboards,Widgets",
    Items: [
      { path: `/bodmas-category`, icon: "blogs", activeTitle: "bodmas-category", title: "Bodmas Test Category", type: "link" },
      { path: `/bodmas-testseries`, icon: "blogs", activeTitle: "bodmas-testseries", title: "Bodmas Test Series", type: "link" },
    ],
  },
  {
    menutitle: " Users",
    menucontent: "Dashboards,Widgets",
    Items: [
      { path: `/user-list`, icon: "blogs", activeTitle: "user-list", title: "Users", type: "link" },
      { path: `/device-change`, icon: "blogs", activeTitle: "device-change", title: "Device Change", type: "link" },
      { path: `/student-attempts`, icon: "blogs", activeTitle: "student-attempts", title: "Exam Attempts", type: "link" },
    ],
  },
  {
    menutitle: "GK Shorts",
    menucontent: "Dashboards,Widgets",
    Items: [
      { path: `/gk-shorts`, icon: "blogs", activeTitle: "gk-shorts", title: "GK Shorts", type: "link" },

    ],
  },
  {
    menutitle: "Teachers",
    menucontent: "Dashboards,Widgets",
    Items: [
      { path: `/teachers`, icon: "blogs", activeTitle: "teachers", title: "Teachers", type: "link" },
      { path: `/teacher-applications`, icon: "blogs", activeTitle: "teacher-applications", title: "Teacher Applications", type: "link" },
    ],
  },
  {
    menutitle: "Class Report",
    menucontent: "Dashboards,Widgets",
    Items: [
      { path: `/class-report`, icon: "others", activeTitle: "class-report", title: "Class Report", type: "link" },
    ],
  },
  {
    menutitle: "Transaction",
    menucontent: "Dashboards,Widgets",
    Items: [
      { path: `/transaction`, icon: "blogs", activeTitle: "transaction", title: "Transaction", type: "link" },

    ],
  },

  {
    menutitle: "General",
    menucontent: "Bouns Pages",
    Items: [
      { path: `/help-support`, icon: "faqs", activeTitle: "help-support", type: "link", active: false, title: "Help Support" },
      { path: `/coupons`, icon: "faqs", activeTitle: "coupons", type: "link", active: false, title: "Coupons" },
      { path: `/enquiries`, icon: "faqs", activeTitle: "enquiries", type: "link", active: false, title: "Enquiries" },
      { path: `/faqs`, icon: "faqs", activeTitle: "faqs", type: "link", active: false, title: "FAQ" },
      { path: `/popup-modal`, icon: "form", activeTitle: "popup-modal", type: "link", title: "Popup Modal" },
      { path: `/sliders`, icon: "form", activeTitle: "sliders", type: "link", title: "Sliders" },
      { path: `/pages`, icon: "form", activeTitle: "pages", type: "link", title: "Pages" },
    ],
  },

];
